import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { bannerService, type Banner, type BannerSlot } from '../services/bannerService';

export interface UseBannersResult {
  banners: Banner[];
  /** True finché la risposta non è arrivata: lo Slot mostra il placeholder. */
  loading: boolean;
}

/**
 * Banner pubblicabili per uno Slot.
 *
 * Attende il completamento del restore della sessione prima di chiamare:
 * il filtro `audience` è server-side e dipende dall'header Authorization,
 * quindi partire durante il restore significa ricevere il set anonimo e
 * mostrarlo a un utente loggato. È lo stesso inciampo già documentato per
 * i prezzi in `HomePage.tsx` (bug del 26/02/2026, hard-refresh).
 */
export function useBanners(slot: BannerSlot): UseBannersResult {
  const { isLoading: authLoading } = useAuth();
  const [banners, setBanners] = useState<Banner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    let cancelled = false;
    setLoading(true);
    bannerService.listBySlot(slot)
      .then(items => { if (!cancelled) { setBanners(items); setLoading(false); } })
      .catch(() => { if (!cancelled) { setBanners([]); setLoading(false); } });
    return () => { cancelled = true; };
  }, [slot, authLoading]);

  return { banners, loading };
}
